const $ = jQuery.noConflict();
import {ScreenLock} from "../../__constants/lock-screen";

export default class WineDataBasePopup {
    static removePopup() {
        $('.single-wine-base.lightbox').remove();
    }

    init() {
        $(document).on('click', '.wine-block-with-score', (e) => {
            e.preventDefault();
            this.apiCall($(e.target).data('post'));
        });

        $(document).on('click', '.single-wine-base .close', () => {
            WineDataBasePopup.removePopup();
            ScreenLock.unlock();
        })
    }

    apiCall(wineID) {
        $.ajax({
            method: 'GET',
            url: `${WP.apiUrl}wines-data-base-popup/`,
            data: {
                wineID
            },
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', WP.apiNonce);
            },
            success: (response) => {
                ScreenLock.lock();
                $('body').append(response.popup);
            },
            fail: (response) => {
                console.log('fail', response);
            },
        });
    }
}
